import { EAnimalTypesUI } from 'data/types/animal.types';
import { TIconNames } from 'components/Base/Icon';
import TextIcon from 'components/Base/TextIcon';
import {
  regexPatterns,
  validationRules,
} from 'components/Base/Form/validationRules';
import { Rule } from '@landlord-tech/ui-kit-opp';

// TODO: Collect all strings in application in one place
export const animalFormFields = {
  type: {
    name: 'type',
    label: 'Animal type',
    placeholder: 'Select animal type',
    rules: [validationRules.required()],
  },
  profilePicture: {
    name: 'profilePicture',
  },
  name: {
    name: 'name',
    label: 'Animal name',
    placeholder: 'Type animal name',
    rules: [
      {
        required: true,
        message: 'This field is required',
        pattern: regexPatterns.onlyWhiteSpace,
      },
    ],
  },
  birthDate: {
    name: 'birthDate',
    label: 'Animal birthdate',
    placeholder: 'Select date',
  },
  species: {
    name: 'species',
    label: 'Species',
    placeholder: 'Select species',
  },
  breed: {
    name: 'breed',
    label: 'Breed',
    placeholder: 'Select breed',
  },
  weight: {
    name: 'weight',
    label: 'Weight (lbs)',
    placeholder: 'Type weight',
    rules: [
      {
        required: false,
        message: 'Value must be greater than 0',
        pattern: regexPatterns.positiveNumbers,
      },
    ],
  },
  primaryColor: {
    name: 'primaryColor',
    label: 'Primary color',
    placeholder: 'Select primary color',
  },
  secondaryColor1: {
    name: 'secondaryColor1',
    placeholder: 'Select additional color',
    label: 'Additional color (optional)',
  },
  secondaryColor2: {
    name: 'secondaryColor2',
    placeholder: 'Select additional color',
    label: 'Additional color (optional)',
  },
  gender: {
    name: 'gender',
    label: 'Choose a gender',
    rules: [],
  },
  neutered: {
    name: 'neutered',
    rules: [],
  },
  houseTrained: {
    name: 'houseTrained',
    rules: [],
  },
  isAggresive: {
    name: 'isAggressive',
    rules: [],
  },
  requiredBecauseOfDisability: {
    name: 'requiredBecauseOfDisability',
    rules: [validationRules.required()],
  },
  trainedFor: {
    name: 'trainedFor',
    rules: [validationRules.required()],
    placeholder: 'Type here',
    label: 'Description',
  },
  aggressionInfo: {
    name: 'aggressionInfo',
    label: 'Please provide details about the incidents of aggression.',
    placeholder: 'Type here',
    rules: [
      {
        required: true,
        // Without this antd accepts "   ", which the server then rejects as a blank Text with an
        // opaque 400 instead of the field saying what is wrong (PP-10177).
        whitespace: true,
        message: 'This field is required!',
      },
    ],
  },
  microchipNumber: {
    name: 'microchip',
    label: 'Microchip number (optional)',
    placeholder: 'Type microchip number',
    rules: [validationRules.microchipNumber()],
  },
  moveInDate: {
    name: 'moveInDate',
    placeholder: 'Select date',
    label: 'Move in date',
    rules: [validationRules.required()],
  },
  observableDisability: {
    name: 'observableDisability',
    rules: [
      { type: 'boolean', required: true, message: 'This field is required!' },
    ] as Rule[],
  },
};

// initialValues and animalFormInitialValues moved to ./animalFormInitialValues, which has no
// component imports so it is unit-testable. Re-exported here for existing importers.
export {
  initialValues,
  animalFormInitialValues,
} from './animalFormInitialValues';

export const typeDropdownItems = [
  { value: EAnimalTypesUI.PET, label: 'Pet' },
  { value: EAnimalTypesUI.ESA, label: 'Emotional Support Animal (ESA)' },
  { value: EAnimalTypesUI.SA, label: 'Service Animal (SA)' },
];

export const genderOptions = [
  {
    label: (
      <TextIcon
        wrap={false}
        icon={TIconNames.FEMALE}
        fontLevel={5}
        label="Female"
        size={12}
      />
    ),
    value: 'female',
  },
  {
    label: (
      <TextIcon
        wrap={false}
        icon={TIconNames.MALE}
        fontLevel={5}
        label="Male"
        size={12}
      />
    ),
    value: 'male',
  },
];
